export { default, type PressableProps } from './Pressable';
